import type { FunctionComponent } from 'react'
import React from 'react'

import { Icon } from '../../Icon'
import type { Icon as IconProps } from '../../Icon/Icon'
import styles from '../Icons.module.scss'

export const TenFtIcon: FunctionComponent<IconProps> = ({
  fill,
  width = 68,
  height = 34,
  ...rest
}) => {
  return (
    <Icon
      data-testid="needs-based-filter-icon-tenFt"
      fill={fill}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      width={width}
      {...rest}
    >
      <g fill="none" fillRule="evenodd">
        <path
          d="M23,0 L7,0 C4.79071525,0 3,1.79071525 3,4 L3,30 C3,32.2092847 4.79071525,34 7,34 L23,34 C25.2092847,34 27,32.2092847 27,30 C27,27.7907153 25.2092847,26 23,26 L13,26 C11.8952847,26 11,25.1047153 11,24 L11,10 C11,8.89528475 11.8952847,8 13,8 L23,8 C25.2092847,8 27,6.20928475 27,4 C27,1.79071525 25.2092847,0 23,0 Z M7,2 L23,2 C24.1047153,2 25,2.89528475 25,4 C25,5.10471525 24.1047153,6 23,6 L13,6 C10.7907153,6 9,7.79071525 9,10 L9,24 C9,26.2092847 10.7907153,28 13,28 L23,28 C24.1047153,28 25,28.8952847 25,30 C25,31.1047153 24.1047153,32 23,32 L7,32 C5.89528475,32 5,31.1047153 5,30 L5,4 C5,2.89528475 5.89528475,2 7,2 Z"
          fill="#00000"
          className={styles.defaultColor}
          fillRule="nonzero"
        />
        <path
          d="M21.5,7 L13.5,7 C11.5668576,7 10,8.56685763 10,10.5 L10,23.5 C10,25.4331424 11.5668576,27 13.5,27 L21.5,27 C23.4331424,27 25,25.4331424 25,23.5 L25,10.5 C25,8.56685763 23.4331424,7 21.5,7 Z M13.5,8 L21.5,8 C22.8808576,8 24,9.11914237 24,10.5 L24,23.5 C24,24.8808576 22.8808576,26 21.5,26 L13.5,26 C12.1191424,26 11,24.8808576 11,23.5 L11,10.5 C11,9.11914237 12.1191424,8 13.5,8 Z"
          fill="#00000"
          className={styles.defaultColor}
          fillRule="nonzero"
        />
        <polygon
          fill="#00000"
          className={styles.defaultColor}
          points="10.5 17 24.5 17 24.5 16 10.5 16"
        />
        <path
          d="M28.4623 16.1565C27.8463 16.5315 27.8463 17.4685 28.4623 17.8435L30.5373 19.1055 32.6133 20.3685C33.2293 20.7425 34.0003 20.2745 34.0003 19.5245L34.0003 17.0005 34.0003 14.4755C34.0003 13.7255 33.2293 13.2575 32.6133 13.6315L30.5373 14.8945 28.4623 16.1565ZM53.5377 16.1565C54.1537 16.5315 54.1537 17.4685 53.5377 17.8435L51.4627 19.1055 49.3867 20.3685C48.7707 20.7425 47.9997 20.2745 47.9997 19.5245L47.9997 17.0005 47.9997 14.4755C47.9997 13.7255 48.7707 13.2575 49.3867 13.6315L51.4627 14.8945 53.5377 16.1565Z"
          fill="#0050B3"
          className={styles.interactiveColor}
        />
        <polygon
          fill="#0050B3"
          className={styles.interactiveColor}
          points="33 18 49 18 49 16 33 16"
        />
        <path
          d="M61,4 L59,4 C57.8957153,4 57,4.89571525 57,6 L57,28 C57,29.1042847 57.8957153,30 59,30 L61,30 C62.1042847,30 63,29.1042847 63,28 L63,6 C63,4.89571525 62.1042847,4 61,4 Z M59,6 L61,6 L61,28 L59,28 L59,6 Z"
          fill="#00000"
          className={styles.defaultColor}
          fillRule="nonzero"
        />
        <path
          d="M63.5,11.5 L62.5,11.5 C61.6718576,11.5 61,12.1718576 61,13 L61,21 C61,21.8281424 61.6718576,22.5 62.5,22.5 L63.5,22.5 C64.3281424,22.5 65,21.8281424 65,21 L65,13 C65,12.1718576 64.3281424,11.5 63.5,11.5 Z M62.5,12.5 L63.5,12.5 C63.7758576,12.5 64,12.7241424 64,13 L64,21 C64,21.2758576 63.7758576,21.5 63.5,21.5 L62.5,21.5 C62.2241424,21.5 62,21.2758576 62,21 L62,13 C62,12.7241424 62.2241424,12.5 62.5,12.5 Z"
          fill="#00000"
          className={styles.defaultColor}
          fillRule="nonzero"
        />
      </g>
    </Icon>
  )
}
